import React from "react";
import Button from "components/atoms/button/index.jsx";

import "./styles.scss";

export default class FormActions extends React.Component {
  render() {
    var back = this.props.back;

    return (
      <div className="formActions">
        {back === true && (
          <div className="back">
            <Button buttonText="Volver" type="back" />
          </div>
        )}

        {this.props.children}
      </div>
    );
  }
}
